import { TBooleanInNumber } from '~/types/main';

export const orderSettingsCast = (data: any) => ({
  isCheckout: Number(data.is_checkout) as TBooleanInNumber,
  isFranchise: Number(data.is_franchise) as TBooleanInNumber,
  isCrossSelling: Number(data.is_cross_selling) as TBooleanInNumber,
  config: {
    vat: String(data.config.vat),
    vatIncluded: Number(data.config.vat_included) as TBooleanInNumber,
    taxableDeliveryFee: Number(data.config.taxable_delivery_fee) as TBooleanInNumber,
    vatRegistrationNumber: String(data.config.vat_registration_number),
    certificateUrl: String(data.config.certificate),
    certificateFilename: String(data.config.certificate_name),
    certificate: new File([], ''),
  },
  notes: {
    smsEditOrder: Number(data.notes.sms_edit_order) as TBooleanInNumber,
    allowNotesAtCheckout: Number(data.notes.allow_notes_at_checkout) as TBooleanInNumber,
    allowItemNotes: Number(data.notes.allow_item_notes) as TBooleanInNumber,
    allowOrderForElse: Number(data.notes.allow_order_for_else) as TBooleanInNumber,
    upsalesFrequency: Number(data.notes.upsales_frequency) as UPSALES_FREQUENCY,
    is_cc_zone_orders: Number(data.notes.is_cc_zone_orders) as TBooleanInNumber,
  },
});

export type TOrderSettings = ReturnType<typeof orderSettingsCast>;

export enum UPSALES_FREQUENCY {
  NEVER,
  EACH_ORDER,
  THREE_ORDERS,
  FIVE_ORDERS,
}

export interface IOrderSettingsErrorMessages {
  vatRegNumber: string | null;
  vat: string | null;
  certificate: string | null;
}
